import { render } from "./ai_build.vue?vue&type=template&id=3d5fb3bd&scoped=true"
import script from "./ai_build.vue?vue&type=script&lang=js"
export * from "./ai_build.vue?vue&type=script&lang=js"

import "./ai_build.vue?vue&type=style&index=0&id=3d5fb3bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5fb3bd"]])

export default __exports__